import React from 'react';

import { Select as AntSelect } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import classNames from 'classnames';

import { CountryState } from '@apis/countries/CountriesApi.types';
import { filterString } from '@helpers/filtering';
import {
    FormSelect,
    FormSelectProps
} from '@molecules/form/formSelect/FormSelect';
import { ShipmentDetailsValidationRules } from '@organisms/shipmentDetails/validationRules';

import styles from './ProvinceSelect.module.less';

const { Option } = AntSelect;

const { shipmentStateRequired } = ShipmentDetailsValidationRules;

export interface ProvinceSelectProps extends Partial<FormSelectProps> {
    onChangeSelectState?: (value: string) => void;
    states?: CountryState[];
    fieldName?: string;
    isRequired?: boolean;
}

const filterStates = (input: string, option?: DefaultOptionType): boolean => {
    const { displayName, provinceCode } = option?.data;
    return (
        filterString(input.trim(), displayName) ||
        filterString(input.trim(), provinceCode)
    );
};

export const ProvinceSelect = ({
    onChangeSelectState,
    states = [],
    isRequired,
    fieldName = 'state',
    ...props
}: ProvinceSelectProps) => {
    return (
        <div
            className={classNames(
                styles.ProvinceSelectContainer,
                props.className
            )}
            id="ProvinceSelect"
        >
            <FormSelect
                {...props}
                onChange={onChangeSelectState}
                required={isRequired}
                fieldName={fieldName}
                title="State/Province"
                initialValue={null}
                showSearch
                allowClear
                optionLabelProp="label"
                filterOption={filterStates}
                placeholder="Select State or Province"
                id="state"
                rules={isRequired ? shipmentStateRequired : []}
                data={states?.map((item, i) => (
                    <Option
                        key={item.stateId}
                        value={item.displayName}
                        data={item}
                        className={styles.Option}
                        id={`StateOption_${i}`}
                    >
                        <div className={styles.Option}>
                            <span
                                id={`StateName_${i}`}
                                className={styles.Option__Name}
                            >
                                {item.displayName}
                                &nbsp;
                            </span>
                            <span>{item.provinceCode}</span>
                        </div>
                    </Option>
                ))}
            />
        </div>
    );
};
